import { render, staticRenderFns } from "./cmsTab.vue?vue&type=template&id=15d9d26c&lang=pug"
import script from "./cmsTab.vue?vue&type=script&lang=js"
export * from "./cmsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports